import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { ModalAlertaComponent } from '@shared/modules/alerta/modal-alerta/modal-alerta.component';
import { ModalBtnsComponent } from '@shared/modules/alerta/modal-btns/modal-btns.component';
import {
  StatusProcessamento,
  StatusProcessamentoMessage,
} from '@shared/utils/interfaces/status-processamento.interface';
import { throwError } from 'rxjs';
import { ModalBotaoUnicoComponent } from './modal-botao-unico/modal-botao-unico.component';

@Injectable()
export class AlertaService {
  constructor(private bottomSheet: MatBottomSheet) {}

  show(titulo: string, mensagem: string) {
    const config: MatBottomSheetConfig = {
      data: {
        titulo,
        mensagem,
      },
      panelClass: 'alerta-modal-custom',
      disableClose: true,
    };
    this.bottomSheet.open(ModalAlertaComponent, config);
  }

  showAlert(titulo: string, mensagem: string) {
    const config: MatBottomSheetConfig = {
      data: {
        titulo,
        mensagem,
      },
      panelClass: 'alerta-modal-custom',
      disableClose: true,
    };
    return this.bottomSheet.open(ModalAlertaComponent, config);
  }

  showConfirm(titulo: string, mensagem: string, textoBtnSecundario: string, textoBtnPrimario: string) {
    const config: MatBottomSheetConfig = {
      panelClass: 'alerta-modal-custom',
      data: {
        titulo,
        mensagem,
        textoBtnSecundario,
        textoBtnPrimario,
      },
      disableClose: true,
    };
    return this.bottomSheet.open(ModalBtnsComponent, config);
  }

  modalBotaoUnico(titulo: string, mensagem: string, textoBtnPrimario: string, isBtnFechar = true) {
    const config: MatBottomSheetConfig = {
      panelClass: 'alerta-modal-custom',
      data: {
        titulo,
        mensagem,
        textoBtnPrimario,
        isBtnFechar,
      },
      disableClose: true,
    };
    return this.bottomSheet.open(ModalBotaoUnicoComponent, config);
  }

  handleHttpError(error: HttpErrorResponse) {
    if (error.status > 400 && error.status < 500) {
      const err: StatusProcessamento = error.error.statusProcessamento;
      const message: StatusProcessamentoMessage = JSON.parse(String(err.message));
      this.show(message.errors[0].title, message.errors[0].detail);
    }

    return throwError(error);
  }

  handleHttpErrorToken(error: HttpErrorResponse) {
    if (error.status > 400 && error.status < 500) {
      const err: StatusProcessamento = error.error.statusProcessamento;
      const message: StatusProcessamentoMessage = JSON.parse(String(err.message));
      this.showAlert(message.errors[0].title, message.errors[0].detail)
        .afterDismissed()
        .subscribe((retorno) => {
          if (window['nativeServiceBridge'] && window['nativeServiceBridge'].close) {
            window['nativeServiceBridge'].close('6', 'false');
          }
        });
    }

    return throwError(error);
  }

  handleHttpConfirmacao(error: HttpErrorResponse) {
    if (error.status > 400 && error.status < 500) {
      const err: StatusProcessamento = error.error.statusProcessamento;
      const message: StatusProcessamentoMessage = JSON.parse(String(err.message));
      this.showAlert(message.errors[0].title, message.errors[0].detail)
        .afterDismissed()
        .subscribe((retorno) => {
          console.log('restasdasda');
        });
    }

    return throwError(error);
  }
}
